import React from "react";
import { Card } from "react-bootstrap";

const AboutCard = ({ image, title, contents, readMore, showReadMore = true, className = "" }) => {
  const cardImageStyle = {
    height: "180px",
    objectFit: "cover",
    borderRadius: "0.75rem 0.75rem 0 0",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "#EB5B00",
    fontWeight: "500",
    cursor: "pointer",
  };

  return (
    <div className={`my-3 ${className}`}>
      <Card className="shadow-sm rounded-4" style={{ minHeight: "370px" }}>
        <Card.Img variant="top" src={image} alt={title} style={cardImageStyle} />
        <Card.Body>
          <Card.Title className="fs-5 fw-bold">{title}</Card.Title>
          <Card.Text className="text-muted" style={{ fontSize: "0.95rem" }}>
            {contents}
          </Card.Text>
          {showReadMore && (
            <Card.Link style={linkStyle} onClick={readMore}>
              Read More
            </Card.Link>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default AboutCard;
